// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__5WqNa","errors":"Errors_errors__-zt7Q"};